// src/screens/AccountSettings.tsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserEdit, FaTrashAlt } from 'react-icons/fa';
import {
  fetchUserProfile,
  updateUserProfile,
  deleteUser
} from '../../store/reducers/authReducer';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import './AccountSettings.css';
import ConfirmModal from './ConfirmModal/ConfirmModal';
const AccountSettings: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    profile,
    isFetchingProfile,
    profileError,
    isUpdatingProfile,
    isLoading: isDeleting,
    error
  } = useAppSelector(state => state.auth);

  const [fullName, setFullName] = useState('');
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [ownedPropertiesColor, setOwnedPropertiesColor] = useState('#ffffff');
  const [confirmOpen, setConfirmOpen] = useState(false)

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profile) {
      setFullName(profile.fullName);
      setUserName(profile.userName);
      setEmail(profile.email);
      setOwnedPropertiesColor(profile.buildingColor);
    }
  }, [profile]);

  const handleUpdateProfile = () => {
    dispatch(updateUserProfile({
      fullName,
      userName,
      email,
      buildingColor: ownedPropertiesColor
    }));
  };

  const handleDeleteAccount = () => {
    setConfirmOpen(true)
  }

  const confirmDelete = () => {
    setConfirmOpen(false)
    const userId = localStorage.getItem('userId')
    if (!userId) return
    dispatch(deleteUser(userId))
      .unwrap()
      .then(msg => {
        alert(msg)
        navigate('/login')
      })
      .catch(err => {
        console.error('Delete failed:', err)
      })
  }

  if (isFetchingProfile) {
    return <div className="loading">Loading your settings…</div>;
  }
  if (profileError) {
    return <div className="error">Error: {profileError}</div>;
  }

  return (
    <div className="account-settings-container">
      <header className="account-settings-header">
        <h1>Account Settings</h1>
      </header>

      <div className="account-settings-form">
        <div className="form-group">
          <label>Full Name</label>
          <input
            type="text"
            value={fullName}
            onChange={e => setFullName(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Username</label>
          <input
            type="text"
            value={userName}
            onChange={e => setUserName(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>

        <div className="form-group color-picker-group">
          <label>Owned Properties Color</label>
          <div className="color-ring">
            <input
              type="color"
              value={ownedPropertiesColor}
              onChange={e => setOwnedPropertiesColor(e.target.value)}
            />
          </div>
        </div>

        {error && <div className="error">{error}</div>}

        <div className="button-group">
          <button
            type="button"
            className="delete-account-button"
            onClick={handleDeleteAccount}
            disabled={isDeleting}
          >
            <FaTrashAlt className="btn-icon" />
            {isDeleting ? 'Deleting…' : 'Delete Account'}
          </button>

          <button
            type="button"
            className="update-profile-button"
            onClick={handleUpdateProfile}
            disabled={isUpdatingProfile}
          >
            {isUpdatingProfile
              ? 'Updating…'
              : <>
                <FaUserEdit className="btn-icon" /> Update Profile
              </>
            }
          </button>
          <ConfirmModal
            isOpen={confirmOpen}
            title="Confirm Deletion"
            message="Are you sure you want to delete your account? This cannot be undone."
            onCancel={() => setConfirmOpen(false)}
            onConfirm={confirmDelete}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;
